import styled from "@emotion/styled";
import { FC } from "react";
import { Field } from "react-final-form";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { RadioOptionFinalForm } from "components/form";
import Block from "components/layout/Block";
import { IDeviceListItem } from "interfaces/entities/devices";
import { WebpushPreferences } from "store/entities/agents";
import { withVar } from "themes/helpers";

interface IProps {
  deviceList: IDeviceListItem[];
}

interface IPreferences {
  type: WebpushPreferences;
  title: string;
  description: string;
}

const preferencesData: IPreferences[] = [
  {
    type: WebpushPreferences.Always,
    title: "Always enabled",
    description: "Get notifications whenever HelpDesk is open or closed in the browser tab.",
  },
  {
    type: WebpushPreferences.WhenOnline,
    title: "Enable only when HelpDesk is open",
    description: "Get notifications only when HelpDesk is open in the browser tab.",
  },
  {
    type: WebpushPreferences.WhenOffline,
    title: "Enable only when HelpDesk is closed",
    description: "Get notifications only when HelpDesk is closed in the browser tab.",
  },
];

const NotificationsPreferences: FC<IProps> = ({ deviceList }) => {
  const shouldRadioBeDisabled = deviceList.length === 0;

  return (
    <Container>
      <Text customColor={shouldRadioBeDisabled ? withVar(DesignToken.ContentBasicDisabled) : undefined}>
        <b>Preferences</b>
        <Text>In any preference setting, your browser must be running, even in the background.</Text>
      </Text>
      <Block>
        {preferencesData.map(item => (
          <Field
            key={item.type}
            component={RadioOptionFinalForm}
            name="settings.webpushNotificationsActive"
            value={item.type}
            type="radio"
            disabled={shouldRadioBeDisabled}
          >
            <Text>{item.title}</Text>
            <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
              {item.description}
            </Text>
          </Field>
        ))}
      </Block>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing4});
`;

export default NotificationsPreferences;
